import styled from "styled-components";

export const Avatar = styled.img`
  height: 47px;
  width: 47px;
  object-fit: cover;
  margin-right: 1rem;
  border-radius: 50%;  
`;
